// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"515":"1a290e1d","691":"94fc8201","980":"1a290e1d"}[chunkId] + ".chunk.css";
};